import { createContext, useContext, useState } from 'react';

const SidebarContext = createContext();

/** Read initial view and roomId from URL so reload keeps the correct page state. */
function getInitialViewFromUrl() {
  if (typeof window === 'undefined') return { view: 'Dashboard', roomId: null };
  const path = window.location.pathname;
  const designMatch = path.match(/^\/design\/(\d+)\/?$/);
  if (designMatch) return { view: 'Photorealistic', roomId: Number(designMatch[1]) };
  if (path === '/projects' || path.startsWith('/projects/')) return { view: 'Projects', roomId: null };
  if (path === '/start-designing' || path.startsWith('/start-designing/')) return { view: 'StartDesigning', roomId: null };
  if (path === '/supplier' || path.startsWith('/supplier/')) return { view: 'Supplier', roomId: null };
  if (path === '/upload-product' || path.startsWith('/upload-product/')) return { view: 'UploadMaterial', roomId: null };
  if (path === '/search') return { view: 'Search', roomId: null };
  return { view: 'Dashboard', roomId: null };
}

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [currentView, setCurrentView] = useState(() => getInitialViewFromUrl().view); // 'Dashboard' | 'StartDesigning' | 'Photorealistic' | 'Supplier' | 'UploadMaterial' | 'Search'
  const [photorealisticImage, setPhotorealisticImage] = useState(null); // data URL when opening Photorealistic page
  const [supplierUploadedImage, setSupplierUploadedImage] = useState(null); // data URL for Supplier -> Upload Material flow (preview)
  const [supplierUploadedFile, setSupplierUploadedFile] = useState(null); // original File for Supplier -> Upload Material (binary upload)
  const [roomId, setRoomId] = useState(() => getInitialViewFromUrl().roomId);
  const [roomImageId, setRoomImageId] = useState(null); // from POST /rooms/{id}/images
  const [roomImageDimensions, setRoomImageDimensions] = useState(null); // { width, height } from API when available

  return (
    <SidebarContext.Provider value={{
      currentView,
      setCurrentView,
      photorealisticImage,
      setPhotorealisticImage,
      supplierUploadedImage,
      setSupplierUploadedImage,
      supplierUploadedFile,
      setSupplierUploadedFile,
      roomId,
      setRoomId,
      roomImageId,
      setRoomImageId,
      roomImageDimensions,
      setRoomImageDimensions,
    }}>
      {children}
    </SidebarContext.Provider>
  );
};
